import { reportErrorToSentry } from '../../../configuration/setup/sentry';

export type ProductConfig = {
    iconName?: string;
    freeTrial?: FreeTrialProductConfig;
    termsOfServiceUrl?: string;
    applicationLink?: string;
    marketplaceLink?: string;
    redirectUrl?: string;
    descriptionOfServiceUrl?: string;
    levelConfig?: Record<string, LevelConfig>;
};

export type FreeTrialProductConfig = {
    productName: string;
    level: string;
};

export type LevelConfig = {
    redirectUrl: string;
    descriptionOfServiceUrl: string;
    termsOfServiceUrl?: string;
};

export const LOCALE_PLACEHOLDER = 'LOCALE';

export function replaceLocalePlaceholder(url: string, locale: string) {
    return url.replace(LOCALE_PLACEHOLDER, locale.substring(0, 2));
}

const OPENMARKETPLACE_BASE_URL = `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/`;

const PRODUCT_CONFIG_BY_ID: Record<string, ProductConfig> = {
    // Regular services
    'man-sku00000004': {
        applicationLink: 'https://remotedownload.rio.cloud/#archive',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/compliant-m',
        iconName: 'Compliant',
        freeTrial: {
            productName: 'Compliant M',
            level: '21',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos`,
        levelConfig: {
            '20-ft': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '21': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '22': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '22-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '23-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '24': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
            '26-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/compliant-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos/m`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos/m`,
            },
        },
    },
    'man-sku00000005': {
        applicationLink: 'https://perform.rio.cloud/#fleet',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/perform',
        iconName: 'Perform',
        freeTrial: {
            productName: 'Perform',
            level: '15',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/perform/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/perform`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/perform/dos`,
    },
    'man-sku00000026': {
        iconName: 'Jupiter',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-now`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/dos`,
    },
    'rio-sku00000027': {
        applicationLink: 'https://drivingtime.rio.cloud/#realtime',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/timed',
        iconName: 'Timed',
        freeTrial: {
            productName: 'Timed',
            level: '15',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/timed/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/timed`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/timed/dos`,
    },
    'rio-sku00000047': {
        applicationLink: 'https://livemonitor.rio.cloud/#map',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/geo',
        iconName: 'Geo',
        freeTrial: {
            productName: 'Geo',
            level: '15',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/geo`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo/dos`,
        levelConfig: {
            '34': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/geo-l`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo/dos/l`,
                termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo/tos/l`,
            },
        },
    },
    'man-sku00000048': {
        iconName: 'One_Minute_Locator',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/one-minute-locator/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/one-minute-locator`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/one-minute-locator/dos`,
    },
    'man-sku00000049': {
        applicationLink: 'https://manservicecare.rio.cloud/',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-servicecare-m',
        iconName: 'MAN_ServiceCare',
        freeTrial: {
            productName: 'MAN ServiceCare M',
            level: '21',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/tos/s-m`,
        levelConfig: {
            '10': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/s`,
            },
            '14': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/s`,
            },
            '15': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/s`,
            },
            '20': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '20-ft': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '21': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '22': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '22-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '23-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '24': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
            '26-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-servicecare-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-servicecare/dos/m`,
            },
        },
    },
    'man-sku00000050': {
        applicationLink: 'https://ota-charging.rio.cloud/#overview',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-emanager-m',
        iconName: 'MAN_eManager',
        freeTrial: {
            productName: 'MAN eManager M',
            level: '25',
        },
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/tos/s-m`,
        levelConfig: {
            '10': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/s`,
            },
            '14': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/s`,
            },
            '15': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/s`,
            },
            '20-ft': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '20': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '21': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '22': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '23-io': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '24': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
            '25': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
            },
        },
    },
    'kor-sku00000053': {
        iconName: 'MAN_ServiceCare',
        termsOfServiceUrl: 'https://rio.cloud/en/documents/man-servicecare/tos/s-m',
        descriptionOfServiceUrl: 'https://rio.cloud/en/documents/man-servicecare/dos/s',
        redirectUrl: 'https://rio.cloud/en/marketplace/produkt/man-servicecare-s',
    },
    'rio-sku00000055': {
        iconName: 'Geo_Data_Flow',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo-data-flow/tos`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/geo-data-flow/dos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/geo-data-flow`,
    },
    'rio-sku00000056': {
        iconName: 'Timed_Data_Flow',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/timed-data-flow/tos`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/timed-data-flow/dos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/timed-data-flow`,
    },
    'man-sku00000061': {
        iconName: 'MinimalDataSet',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/minimaldatenset/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-emanager-m`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-emanager/dos/m`,
    },
    'man-sku00000066': {
        applicationLink: 'https://simplepay.rio.cloud/',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-simplepay',
        iconName: 'Jupiter',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-simplepay/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-simplepay`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-simplepay/dos`,
    },
    'man-sku00000073': {
        applicationLink: 'https://rio.cloud/en/marketplace/produkt/man-datapackage-tigr/next-steps',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-datapackage-tigr',
        iconName: 'DataProvision',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/tos/s-tigr`,
        levelConfig: {
            '10': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/s`,
            },
            '14': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/s`,
            },
            '15': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-s`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/s`,
            },
            '20': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-tigr`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/tigr`,
            },
            '24': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-tigr`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/tigr`,
            },
            '25': {
                redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-datapackage-tigr`,
                descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-datapackage/dos/tigr`,
            },
        },
    },
    'man-sku00000081': {
        applicationLink: 'https://jupiter.rio.cloud/',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-simplepay',
        iconName: 'Jupiter',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-simplepay/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-simplepay`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-simplepay/dos`,
    },
    'man-sku00000085': {
        applicationLink: 'https://livemonitor.rio.cloud/',
        marketplaceLink: 'https://rio.cloud/en/marketplace/produkt/man-smartroute',
        iconName: 'SmartRoutePlanning',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-smartroute/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/man-smartroute`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-smartroute/dos`,
    },
    'rio-sku00000094': {
        applicationLink: 'https://ordercom.cartright.rio.cloud/#/welcome',
        marketplaceLink: 'https://rio.cloud/en/documents/order-communication/how-to/user-manual',
        iconName: 'OrderCommunication',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/order-communication`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/dos`,
    },
    'man-sku00000098': {
        iconName: 'Compliant',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/tos`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/compliant/dos`,
    },
    'zaf-sku00000100': {
        iconName: 'MAN_ServiceCare',
        termsOfServiceUrl: 'https://rio.cloud/en/documents/man-servicecare/tos/s-m',
        redirectUrl: 'https://rio.cloud/en/marketplace/produkt/man-servicecare-s',
        descriptionOfServiceUrl: 'https://rio.cloud/en/documents/man-servicecare/dos/s',
    },
    'rio-sku00000101': {
        iconName: 'Fleet', // Workaround until actual icon is available
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/tos`,
    },
    'rio-sku00000102': {
        iconName: 'Staff', // Workaround until actual icon is available
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/order-communication`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/dos`,
    },
    // MAN Now features / subscriptions
    'man-sku00000052': {
        iconName: 'MAN-Now-MapUpdate',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/order-communication`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/order-communication/dos`,
    },
    'man-sku00000060': {
        iconName: 'MAN-Now-OnlineTraffic',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/tos`,
    },
    'man-sku00000072': {
        iconName: 'MAN-Now-EfficientRoute',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/tos`,
    },
    'man-sku00000076': {
        iconName: 'MAN-Now-OnlineNews',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/man-now/tos`,
    },
    // Test products
    'rio-sku00000051': {
        iconName: 'Maintenance',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/cypress-connect`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/dos`,
    },
    'rio-sku00000058': {
        iconName: 'Maintenance',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/cypress-connect`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/dos`,
    },
    'rio-sku00000059': {
        iconName: 'Maintenance',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/cypress-connect`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/dos`,
    },
    'rio-sku00000071': {
        iconName: 'Staff',
        termsOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/tos`,
        redirectUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/marketplace/produkt/cypress-connect`,
        descriptionOfServiceUrl: `https://rio.cloud/${LOCALE_PLACEHOLDER}/documents/cypress-connect/dos`,
    },
};

export function getFreeTrialConfig(sku: string): FreeTrialProductConfig | undefined {
    return PRODUCT_CONFIG_BY_ID[sku.toLowerCase()]?.freeTrial;
}

export function getRedirectConfig(locale: string, sku: string, level?: string): string | undefined {
    const productConfig = PRODUCT_CONFIG_BY_ID[sku.toLowerCase()];

    if (productConfig?.levelConfig && level && productConfig.levelConfig[level]) {
        return replaceLocalePlaceholder(productConfig.levelConfig[level].redirectUrl, locale);
    }

    if (productConfig?.redirectUrl) {
        return replaceLocalePlaceholder(productConfig.redirectUrl, locale);
    }

    return;
}

export function getProductIconUrl(sku: string): string | undefined {
    const productIconName = PRODUCT_CONFIG_BY_ID[sku.toLowerCase()]?.iconName;

    if (!productIconName) {
        return;
    }

    return `https://rio.cloud/fileadmin/Marketplace/AppIcons/${productIconName}.svg`;
}

export function getApplicationLink(sku?: string): string | undefined {
    if (!sku) {
        return;
    }

    return PRODUCT_CONFIG_BY_ID[sku.toLowerCase()]?.applicationLink;
}

export function getOpenMarketplaceProductLink(sku?: string): string | undefined {
    if (!sku) {
        return;
    }

    return PRODUCT_CONFIG_BY_ID[sku.toLowerCase()]?.marketplaceLink;
}

export function getOpenMarketplaceLink(): string {
    return replaceLocalePlaceholder(OPENMARKETPLACE_BASE_URL, 'en-GB');
}

export function getLocalizedOpenMarketplaceLink(locale: string): string {
    return replaceLocalePlaceholder(OPENMARKETPLACE_BASE_URL, locale);
}

export function getDescriptionOfServiceUrl(locale: string, sku: string, level?: string) {
    const productConfig = PRODUCT_CONFIG_BY_ID[sku.toLowerCase()];

    if (productConfig?.levelConfig && level && productConfig.levelConfig[level]) {
        return replaceLocalePlaceholder(productConfig.levelConfig[level].descriptionOfServiceUrl, locale);
    }

    if (productConfig?.redirectUrl && productConfig?.descriptionOfServiceUrl) {
        return replaceLocalePlaceholder(productConfig.descriptionOfServiceUrl, locale);
    }

    return;
}
export const getTermsAndConditionsUrl = (locale: string, sku: string, level?: string) => {
    const productConfig = PRODUCT_CONFIG_BY_ID[sku.toLowerCase()];
    const genericTos = productConfig?.termsOfServiceUrl;
    const levelSpecificTos = level && productConfig?.levelConfig?.[level]?.termsOfServiceUrl;

    if (levelSpecificTos) {
        return replaceLocalePlaceholder(levelSpecificTos, locale);
    }
    if (genericTos) {
        return replaceLocalePlaceholder(genericTos, locale);
    }
    reportErrorToSentry(
        new Error(
            `Called terms and condition for sku ${sku} and level ${level}, but neither specific nor generic tos are configured`
        )
    );
    return;
};
